import { render } from "./BaseCyanButton.vue?vue&type=template&id=473caf62"
import script from "./BaseCyanButton.vue?vue&type=script&lang=js"
export * from "./BaseCyanButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__